export var ACTIONS = {
  SHOW_MEDIA_VIEWER: 'SHOW_MEDIA_VIEWER',
  HIDE_MEDIA_VIEWER: 'HIDE_MEDIA_VIEWER',
  TRACK_MEDIA_PASTE: 'TRACK_MEDIA_PASTE'
};